import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

/* ========================== STATE ============================ */
const state = {
  stateUpdateCounter: 0,
  cache: {
    timeslot_flat_cache: {}

  },
  // view: {
  //   range_start: moment(), // not sure if this is a good idea - NOPE
  //   horizon: 7
  // },
  // optimizer_input: {
    // TODO:
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
